// extracted by mini-css-extract-plugin
module.exports = {"container":"ticker_container__TniVn","messages":"ticker_messages__lE840","message":"ticker_message__4QmPI"};